import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { allAssetsColumns } from '../../datatablesource'
import { handleError } from '../../utils/error';
import newRequest from '../../utils/newRequest';
import Datatable from '../datatable/Datatable'
import "./allAssets.scss"

import { useTranslation } from "react-i18next";
const AllAssets = () => {
    const navigate = useNavigate();
    
  const { t, i18n } = useTranslation();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isAuthenticating, setIsAuthenticating] = useState(true);
    const [allAssetsList, setAllAssetsList] = useState([]);
    
    const getAllAssetsList = async () => {
        try {
            const response = await newRequest.get("/GetAllAssetMasterEncodeAssetCapture")
            setIsAuthenticated(true);
            setIsAuthenticating(false);
            let NewData = response?.data.map((item) => {
                return {
                    ...item,
                    majorCategoryAndMinorCategory: `${item.MajorCategory} + ${item.MInorCategory}`,

                }
            })
            setAllAssetsList(NewData);
            console.log(`Loaded ${NewData.length} total records from database`);
        }
        catch (error) {
            handleError(error)
            setIsAuthenticated(false);
            setIsAuthenticating(false);
        }
    };
    
    useEffect(() => {
        getAllAssetsList();
    }, []);
    
    const handleImportSuccess = () => {
        console.log("Refreshing asset list after import...");
        getAllAssetsList();
    };
    
    return (
      <div>
        <Datatable
          secondaryColor="secondary"
          data={allAssetsList}
          columnsName={allAssetsColumns(t)}
          title={t("ALL ASSETS")}
          loading={isAuthenticating}
          uniqueId="allAssetsId"
          addNewNavigation="/admin/all-assets/add-new"
          deleteBtnEndPoint="/DeleteAssetMasterEncodeAssetCaptureById"
          apiEndPoint="/PostAssetMasterEncodeAssetCapture"
          onImportSuccess={handleImportSuccess}
          actionColumnVisibility={true}
        />
      </div>
    );
}

export default AllAssets